import angular from 'angular';

import { avatarAndBubble } from './material/avatar-and-bubble.directive';
import { message2AvatarAndBubble } from './material/message-formatters.filters';
import { MessagesService } from './messages.services.js';

angular
  .module('messages', [])
  .directive('avatarAndBubble', avatarAndBubble)
  .filter('message2AvatarAndBubble', message2AvatarAndBubble)
  .factory('MessagesFactory', MessagesService.MessagesFactory);
